import React, { useRef, useState } from 'react'
import { BsPlus } from 'react-icons/bs'
import Loader from 'react-loader-spinner'
import '../styles/components/UploadImageWithTextButton.css'
import { toast } from 'react-toastify'
import heic2any from "heic2any";

const UploadImageWithTextButton = ({ onClick, loadingButton }) => {
  const fileInputRef = useRef(null)
  const [selectedImage, setSelectedImage] = useState(null)
  const [text, setText] = useState(null)
  const [isProcessing, setIsProcessing] = useState(false)

  const handleChangeText = (e) => {
    setText(e.target.value)
  }

  const handleButtonClick = () => {
    if (!isProcessing) {
      fileInputRef.current.click()
    }
  }

  const handleFileChange = async (event) => {
    let file = event.target.files[0]
    if (!file) return;
    setIsProcessing(true);
    try {
      // VERIFICAÇÃO DE HEIC
      if (file.type === "image/heic" || file.name.toLowerCase().endsWith(".heic")) {
        toast.info("Convertendo formato de imagem...");

        const convertedBlob = await heic2any({
          blob: file,
          toType: "image/jpeg",
          quality: 0.8
        });

        // Se o HEIC tiver múltiplas imagens, ele retorna um array. Pegamos a primeira.
        file = Array.isArray(convertedBlob) ? convertedBlob[0] : convertedBlob;
      }

      // SEGUE O FLUXO ORIGINAL
      const tempUrl = URL.createObjectURL(file)
      const img = new Image()

      img.onload = () => {
        const canvas = document.createElement('canvas')
        let width = img.width
        let height = img.height

        const MAX_SIZE = 1280
        if (width > height) {
          if (width > MAX_SIZE) {
            height *= MAX_SIZE / width
            width = MAX_SIZE
          }
        } else {
          if (height > MAX_SIZE) {
            width *= MAX_SIZE / height
            height = MAX_SIZE
          }
        }

        canvas.width = width
        canvas.height = height

        const ctx = canvas.getContext('2d')
        ctx.drawImage(img, 0, 0, width, height)

        const compressedBase64 = canvas.toDataURL('image/jpeg', 0.7)
        setSelectedImage(compressedBase64)
        URL.revokeObjectURL(tempUrl)
        setIsProcessing(false);
      }

      img.onerror = () => {
        toast.error("Erro ao processar imagem.")
        setIsProcessing(false);
      }

      img.src = tempUrl

    } catch (error) {
      console.error("Erro na conversão HEIC:", error);
      toast.error("Não foi possível processar esta imagem HEIC.");
      setIsProcessing(false);
    }
  }

  const handleSendButton = () => {
    if (!selectedImage && !isProcessing) {
        return toast.warn("Por favor, selecione uma imagem.");
    }
    onClick({text, image: selectedImage})
  }

  return (
    <div className='upload-container'>
      <div className={'upload-inner-container'} style={{ marginTop: 32 }}>
        <div 
          className={`image-button-container ${isProcessing ? 'disabled' : ''}`} 
          onClick={handleButtonClick}
          style={{ cursor: isProcessing ? 'not-allowed' : 'pointer' }}
        >
          {isProcessing ? (
            <div className='add-image-button-container'>
               <Loader type='TailSpin' color='#bdbdbd' height={40} width={40} />
               <p style={{ fontSize: 12, color: '#bdbdbd', marginTop: 8 }}>Processando...</p>
            </div>
          ) : selectedImage ? (
            <div className='preview-image-container'>
              <img src={selectedImage} alt='Selected' className='preview-image' />
            </div>
          ) : (
            <div className='add-image-button-container'>
              <button className='add-image-button'>
                <BsPlus size={70} color='#bdbdbd' />
              </button>
            </div>
          )}
          
          <input
            type='file'
            accept='image/*'
            ref={fileInputRef}
            style={{ display: 'none' }}
            onChange={handleFileChange}
            disabled={isProcessing}
          />
        </div>
        <textarea
          className='text-area'
          placeholder='Digite algo para a consultora. Ex: Olha este look que eu usei hoje'
          onChange={handleChangeText}
        />
      </div>
      <button
        onClick={handleSendButton}
        className='remeberyou-send-button'
        disabled={loadingButton || isProcessing}
        style={{ opacity: (loadingButton || isProcessing) ? 0.6 : 1 }}
      >
        {loadingButton
          ? <Loader
            type='TailSpin'
            color='white'
            height={17}
            width={17}
          />
          : 'ENVIAR'
        }
      </button>
    </div>
  )
}

export default UploadImageWithTextButton



// WEBPACK FOOTER //
// ./src/components/UploadImageWithTextButton.js